import { render, staticRenderFns } from "./Dict.vue?vue&type=template&id=3ceb39ee&scoped=true"
import script from "./Dict.vue?vue&type=script&lang=js"
export * from "./Dict.vue?vue&type=script&lang=js"
import style0 from "./Dict.vue?vue&type=style&index=0&id=3ceb39ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb39ee",
  null
  
)

export default component.exports